import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Box, TextField, Button, Typography } from '@mui/material';
import Modal from './Modal';
import { makeApiRequest } from '../../Shared/Api';
import { useAppContext, ACTION_TYPES } from '../../Context/AppContext';

const ChangePasswordModal = ({ open }) => {
	const { enqueueSnackbar } = useSnackbar();
	const { dispatch } = useAppContext();
	const [formData, setFormData] = useState({
		currentPassword: '',
		newPassword: '',
		confirmPassword: '',
	});
	const [loading, setLoading] = useState(false);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async () => {
		if (formData.newPassword !== formData.confirmPassword) {
			enqueueSnackbar('New passwords do not match.', { variant: 'error' });
			return;
		}

		setLoading(true);
		try {
			const response = await makeApiRequest('POST', '/auth/change-password/', {
				current_password: formData.currentPassword,
				new_password: formData.newPassword,
			});

			dispatch({
				type: ACTION_TYPES.UPDATE_USER,
				payload: response,
			});

			setFormData({
				currentPassword: '',
				newPassword: '',
				confirmPassword: '',
			});

			enqueueSnackbar('Your password has been updated.', {
				variant: 'success',
			});
		} catch (error) {
			enqueueSnackbar(error.message || 'Failed to update password.', {
				variant: 'error',
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			open={open}
			onClose={() => {}}
			modalTitle="Set Your Password"
			maxWidth="sm"
			useActionButtons
			disableBackdropClick
			disableEscapeKeyDown
			hideCloseButton
			actionButtons={
				<Button
					variant="contained"
					onClick={handleSubmit}
					disabled={
						loading ||
						!formData.currentPassword ||
						!formData.newPassword ||
						!formData.confirmPassword
					}
				>
					{loading ? 'Saving...' : 'Update Password'}
				</Button>
			}
		>
			<Box sx={{ mt: 1 }}>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					For security, please change your temporary password before continuing.
				</Typography>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
					<TextField
						label="Current password"
						name="currentPassword"
						type="password"
						value={formData.currentPassword}
						onChange={handleInputChange}
						fullWidth
						required
						autoComplete="current-password"
					/>
					<TextField
						label="New password"
						name="newPassword"
						type="password"
						value={formData.newPassword}
						onChange={handleInputChange}
						fullWidth
						required
						autoComplete="new-password"
					/>
					<TextField
						label="Confirm new password"
						name="confirmPassword"
						type="password"
						value={formData.confirmPassword}
						onChange={handleInputChange}
						fullWidth
						required
						autoComplete="new-password"
					/>
				</Box>
			</Box>
		</Modal>
	);
};

export default ChangePasswordModal;
